import axios from "axios";
import { ServerSideTypes } from "../../../types/OperationCommonTypes";
import { RfidCardTypes } from "../tasks/Types";

const RfidCardImportService = {
    get: {
        rfidStatus: () => {
            return axios.get<string[]>("/masterdatavehicle/rfidcardimporttracking/status/all").then(
                (response) => response.data,
            )
        },
        all: (tenant: string, data: RfidCardTypes.IFormInput, params: ServerSideTypes.IParams) => {
            return axios.get<ServerSideTypes.IResult<RfidCardTypes.IRfidCardResponse>>("/masterdatavehicle/rfidcardimporttracking", {
                params: {
                    tenant,
                    ...data,
                    ...params,
                }
            }).then(
                response => response.data,
            )
        },
        excel: (tenant: string, data: RfidCardTypes.IFormInput) => {
            return axios.get(`/masterdatavehicle/rfidcardimporttracking/excel`,{
                params: {
                    tenant: tenant, ...data,
                },
                responseType: "arraybuffer"
            }).then(
                (response) => response,
            )
        },
        file: (tenant: string, id: number) => {
            return axios.get(`/masterdatavehicle/rfidcardimporttracking/${id}/file`,
            {
                params: { tenant },
                responseType: "arraybuffer",
            }).then(
                response => response,
            )
        },
        errorFile: (tenant: string, id: number) => {
            return axios.get(`/masterdatavehicle/rfidcardimporttracking/${id}/errorfile`,
            {
                params: { tenant },
                responseType: "arraybuffer",
            }).then(
                response => response,
            )
        }
    }
}
export default RfidCardImportService;
